export default __webpack_public_path__ + "static/media/flexcompute_logo.4c6b5dd9.svg";